import { render, staticRenderFns } from "./mattersOne.vue?vue&type=template&id=1bae2d58&scoped=true&"
import script from "./mattersOne.vue?vue&type=script&lang=js&"
export * from "./mattersOne.vue?vue&type=script&lang=js&"
import style0 from "./mattersOne.vue?vue&type=style&index=0&id=1bae2d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae2d58",
  null
  
)

export default component.exports